import { useLocalization } from "@fluent/react";
import { useNavigate } from "react-router";
import { useToastsContext } from "@lending/hooks/useToasts";
import styles from "./BackButton.module.css";

interface BackButtonProps {
  onClick: () => void | Promise<void>;
}

function BaseBackButton({ onClick }: { onClick: () => void | Promise<void> }) {
  const { l10n } = useLocalization();

  return (
    <button className={styles.backButton} type="button" onClick={onClick}>
      <span className="narmi-icon-chevron-left padding--right--xxs" />
      {l10n.getString("button-label-back", null, "Back")}
    </button>
  );
}

function BackButton({ onClick }: BackButtonProps) {
  return <BaseBackButton onClick={onClick} />;
}

function HistoryBackButton() {
  const navigate = useNavigate();
  const { clearToasts } = useToastsContext();

  return (
    <BaseBackButton
      onClick={() => {
        clearToasts();
        void navigate(-1);
      }}
    />
  );
}

export { BackButton, HistoryBackButton };
